import axios from '@/axios';
import { getLocalStorageItem } from '@/utils/localStorageHelpers';

/**
 * Fetch clinics list for an organization
 * @param {string} organizationId - The organization ID
 * @returns {Promise<Object>} - Response containing clinics data
 */
export const fetchClinics = async (organizationId) => {
  const token = getLocalStorageItem('AccessToken');
  const authHeader = { Authorization: token };
  try {
    return axios.get(`/api/v1/organization/${organizationId}/clinics/list`, {
      headers: authHeader,
    });
  } catch (error) {
    console.error('Error fetching clinics:', error);
    throw error;
  }
};

